import { axios } from '@/services/axios';

const addSSOProvider = async (provider) => {
    const res = await axios.post('/sso/provider', provider);
    return res.data;
};

export default addSSOProvider;
